import React from "react";
import EventsList from "../components/ui/events-list";

const HomePage = () => {
  return <EventsList />;
};

export default HomePage;
